import React, { Component } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import "./Carousel.css";

class ImgCarousel extends Component {
	render() {
		return (
			<Carousel
				className="carousel"
				showArrows={false}
				showIndicators={false}
				showStatus={false}
				infiniteLoop={true}
				showThumbs={false}
				autoPlay={true}
				stopOnHover={false}
				swipeable={true}
				interval={2800}
				transitionTime={150}
			>
				<div>
					<img
						className="carousel__image"
						src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Wireless/Samsung/SamsungM/Family/8thMay/D20729242_IN_WLME_SamsungM_Family_DesktopTallHero_1500x600_1.1._CB669478640_.jpg"
						alt="img"
					/>
				</div>
				<div>
					<img
						className="carousel__image"
						src="https://images-eu.ssl-images-amazon.com/images/G/31/img2020/img21/apparelGW/U599/JUNE/PC/2._CB667373073_.jpg"
						alt="img"
					/>
				</div>
				<div>
					<img
						className="carousel__image"
						src="https://images-eu.ssl-images-amazon.com/images/G/31/AmazonVideo/2021/X-site/SingleTitle/Mauritian/1500x600_Hero-Tall_JPN._CB667162087_.jpg"
					/>
				</div>
				<div>
					<img
						className="carousel__image"
						src="https://images-eu.ssl-images-amazon.com/images/G/31/AmazonVideo/2021/X-site/SingleTitle/SAPF/1500x600_Hero-Tall_JPN._CB668283308_.jpg"
						alt="img"
					/>
				</div>
				<div>
					<img
						className="carousel__image"
						src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Wireless/OnePlusNordNewLaunch/28th/GW/D23753221_OnePlus_Nord_New_launch_GW_Design_SIM_Tall_hero_1500x600._CB668899827_.jpg"
						alt="img"
					/>
				</div>
				<div>
					<img
						className="carousel__image"
						src="https://images-na.ssl-images-amazon.com/images/G/15/digital/video/merch/2021/TV/BRND/BRND_MTH21_GWBleedingHero_1500x600_Final_en-CA_FT_PVD6862._CB670220811_.jpg"
						alt="img"
					/>
				</div>
				<div>
					<img
						className="carousel__image"
						src="https://images-eu.ssl-images-amazon.com/images/G/31/AmazonVideo/2021/X-site/SingleTitle/WW84/Launch/1500x600_Hero-Tall_JPN._CB669639160_.jpg"
						alt="img"
					/>
				</div>
				<div>
					<img
						className="carousel__image"
						src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Wireless/Samsung/SamsungM/M12/GW_April/90HzRate/D21200796_IN_WLME_SamsungGalaxy_M12_New_Launch_DesktopTallHero_1500x600_4._CB655655622_.jpg"
						alt="img"
					/>
				</div>
				<div>
					<img
						className="carousel__image"
						src="https://images-eu.ssl-images-amazon.com/images/G/31/prime/Gateway/2021/desktop-1x._CB658860139_.jpg"
						alt="img"
					/>
				</div>
				<div>
					<img
						className="carousel__image"
						src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Wireless/OnePlusNordNewLaunch/31st/GW/D23753221_OnePlus_Nord_New_launch_GW_Design_SIM_Tall_hero_1500x600._CB667064660_.jpg"
						alt="img"
					/>
				</div>
				<div>
					<img
						className="carousel__image"
						src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Tablets/BAU/best-selling-tablets-_logo_desktophero_1500x600._CB667036065_.jpg"
						alt="img"
					/>
				</div>
				<div>
					<img
						className="carousel__image"
						src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Wireless/WLA/May/Headsets/OnePlusBudsSeries/EndsToday/D23519665_WLA_OnePlus_Buds_Series_Tall_Hero_1500x600._CB667108531_.jpg"
						alt="img"
					/>
				</div>
				<div>
					<img
						className="carousel__image"
						src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Audio/Boat/Rockerz330/Launch/tallhero/Boat_Gww_1500x600._CB668946855_.jpg"
						alt="img"
					/>
				</div>
				<div>
					<img
						className="carousel__image"
						src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Wireless/OPPO/A74/17990_WOBO/V348719848_IN_WLD_OPPO_A74_TallHero_1500x600._CB669473435_.jpg"
						alt="img"
					/>
				</div>
				<div>
					<img
						className="carousel__image"
						src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Beauty/GW/May/21-Essential-Beauty-Header--1500x600._CB668804977_.jpg"
						alt="img"
					/>
				</div>
				<div>
					<img
						className="carousel__image"
						src="https://images-eu.ssl-images-amazon.com/images/G/31/img2020/img21/apparelGW/U599/MAY/PC_1X._CB669362648_.jpg"
						alt="img"
					/>
				</div>
				<div>
					<img
						className="carousel__image"
						src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Wireless/Xiaomi/Redmi_EVOSeries/Note10/GW/May/D21342465_WLD_Mi_Redmi_Note10_tallhero_1500x600._CB667019283_.jpg"
						alt="img"
					/>
				</div>
				<div>
					<img
						className="carousel__image"
						src="https://images-fe.ssl-images-amazon.com/images/G/65/2021/Fresh/GatewayBanner_1500x600._CB668321692_.jpg"
						alt="img"
					/>
				</div>
				<div>
					<img
						className="carousel__image"
						src="https://images-eu.ssl-images-amazon.com/images/G/31/img20/Events/SFH21/MSO/SFH_Hero_PC_1x._CB667323714_.jpg"
						alt="img"
					/>
				</div>
				<div>
					<img
						className="carousel__image"
						src="https://images-eu.ssl-images-amazon.com/images/G/31/img21/Wireless/Samsung/SamsungM/MSD_2/Family/D23416955_MSD_IN_WLME_May_Samsung_Family_DesktopTallHero_1500x600R._CB667112482_.jpg"
						alt="img"
					/>
				</div>
			</Carousel>
		);
	}
}

export default ImgCarousel;
